
<!-- partial:partials/_navbar.html -->
<nav class="navbar default-layout-navbar col-lg-12 col-12 p-0 d-flex flex-row" *ngIf="router.url.includes('/casino-detail')">
    <div class="text-center navbar-brand-wrapper d-flex align-items-center justify-content-center">
        <a href="javascript:void(0);" [routerLink]="['/home']" style=" font-size: 20px; color: #fff; margin-left: 10px;"><i class="mdi mdi-home"></i></a>
        <a class="navbar-brand brand-logo" href="javascript:void(0)" [routerLink]="['/home']"><img src="assets/img/{{env.host.name}}/logo.png" alt="logo" /></a>
    </div>
    <div class="navbar-nav-right">
        <span style="color:#fff;font-size: 12px; text-transform:capitalize; margin-right: 5px;">{{userData?.username}}</span>
    </div>
</nav>

<nav class="navbar default-layout-navbar col-lg-12 col-12 p-0 d-flex flex-row" *ngIf="!router.url.includes('/casino-detail')">
    <div class="text-center navbar-brand-wrapper d-flex align-items-center justify-content-center">
        <a class="navbar-brand brand-logo" href="javascript:void(0)" [routerLink]="['/home']"><img src="assets/img/{{env.host.name}}/logo.png" alt="logo" /></a>
    </div>
    <div class="navbar-menu-wrapper d-flex align-items-stretch">
        <button *ngIf="!router.url.includes('/home')" class="navbar-toggler navbar-toggler align-self-center" type="button" data-toggle="minimize">
            <span class="fa fa-navicon"></span>
        </button>
        <div class="search-field d-none">
            <form class="d-flex align-items-center h-100" action="#">
                <div class="input-group">
                    <div class="input-group-prepend bg-transparent">
                        <i class="input-group-text border-0 mdi mdi-magnify"></i>
                    </div>
                    <input type="text" class="form-control bg-transparent border-0" placeholder="Search projects">
                </div>
            </form>
        </div>

        <ul class="navbar-nav navbar-nav-right" *ngIf="isLogin()">
            <li class="nav-item btns__deposit_withdrawal d-mob-none" *ngIf="depoWithdrawCondition()">
                <button class="nav-link btn btn-block btn-gradient-primary btn-sm font-weight-medium auth-form-btn  btn_deposit" routerLink="/deposit">
                    <img src="http://speedcdn.io/assets/mangoo777-client/deposit.svg" class="img-fluid"> deposit
                </button>
            </li>
            <li class="nav-item btns__deposit_withdrawal d-mob-none" *ngIf="depoWithdrawCondition()">
                <button class=" nav-link btn btn-block btn-gradient-primary btn-sm font-weight-medium auth-form-btn btn_withdrawal"  routerLink="/withdraw">
                    <img src="http://speedcdn.io/assets/mangoo777-client/withdraw.svg" class="img-fluid"> withdrawa
                </button>
            </li>
            <li class="nav-item dropdown baEx">
                <a class="nav-link dropdown-toggle" href="javascript:void(0);" data-bs-toggle="dropdown" aria-expanded="false">
                    <div class="nav-profile-text">
                        <img class="img-fluid" src="assets/img/coin.svg">
                        <!-- <div> -->
                            <span>{{fixedPostDecimal(userData?.available_balance)}}</span>
                            <!-- <span></span>{{fixedPostDecimal(positiveVal(userData?.expose))}}</span> -->
                        <!-- </div> -->
                    </div>
                </a>
                <div class="dropdown-menu navbar-dropdown">
                    <p>balance: <i>{{fixedPostDecimal(userData?.available_balance)}}</i></p>
                    <p routerLink="/market-analysis" [ngClass]="userData?.expose >= 0 ? 'profit' : 'loss'">exposure: <i>{{positiveVal(fixedPostDecimal(userData?.expose))}}</i></p>
                    <div class="balance-information" *ngIf="userData?.wager_active == 1">
                        <p>Wallet Amount <small>(Inclusive bonus)</small><i>{{balInfo.wall_amt}}</i></p>
                        <p>Net Exposure<i>{{balInfo.net_expo}}</i></p>
                        <p>Bonus<i>{{balInfo.bonus}}</i></p>
                        <p>Available Withdrawal<i>{{balInfo.avail_withdrawal}}</i></p>
                        <!-- <p [routerLink]="['/reffer-and-earn']" class="rae_btns">Refer and Earn</p> -->
                        <p [routerLink]="['/bonus-list']" class="ab_btns">Awaiting Bonus <i>{{balInfo.await_bonus}}</i></p>
                        <!-- <p (click)="openBonusRule()" class="">Bonus Rule</p> -->
                    </div>
                </div>
            </li>
            <li class="nav-item nav-profile dropdown">
                <a class="nav-link dropdown-toggle" href="javascript:void(0)" (click)="closeSidebarIfOpen();" data-bs-toggle="dropdown" aria-expanded="false">
                    <div class="nav-profile-img">
                        <i class="fa-solid fa-user"></i>
                        <span class="availability-status online d-none"></span>
                    </div>
                    <div class="nav-profile-text">
                        <p class="mb-1 text-black">{{userData?.username}}</p>
                    </div>
                </a>
                <div class="dropdown-menu navbar-dropdown" aria-labelledby="profileDropdown">
                    <a class="dropdown-item" href="javascript:void(0)" routerLink="/profile">Profile</a>
                    <a class="dropdown-item" href="javascript:void(0)" routerLink="/reports/account-statement">account statement </a>
                    <a class="dropdown-item" href="javascript:void(0)" routerLink="/stake-setting">stake setting </a>
                    <a class="dropdown-item" href="javascript:void(0)" routerLink="/reports/profit-loss">profit & loss </a>
                    <a class="dropdown-item" href="javascript:void(0)" routerLink="/reports/unsettled-bets">Unsettled Bets</a>
                    <!-- <a class="dropdown-item" href="javascript:void(0)" routerLink="/reports/sport-summary-report">Sports Summary</a> -->
                    <!-- <a class="dropdown-item" href="javascript:void(0)" href="result.php">result </a> -->
                    <a class="dropdown-item" href="javascript:void(0)" routerLink="/change-password">change password </a>
                    <a class="dropdown-item" href="javascript:void(0)" routerLink="/rules">rules </a>
                    <a class="dropdown-item" *ngIf="userData?.wager_active == 1" href="javascript:void(0)" routerLink="/reffer-and-earn">Refer and Earn </a>
                    <a class="dropdown-item" *ngIf="userData?.wager_active == 1" href="javascript:void(0)" (click)="openBonusRule()">Bonus Rule </a>
                    <div class="dropdown-divider"></div>
                    <a class="dropdown-item" href="javascript:void(0)" (click)="logOut()">
                        <!-- <img class="img-fluid" src="assets/img/icons/logout.svg"> -->
                        Signout
                    </a>
                </div>
            </li>
        </ul>
        <ul class="navbar-nav navbar-nav-right sign-in-nav" *ngIf="!isLogin()">
            <li class="nav-item">
                <button class="btn btn-block btn-gradient-primary btn-sm font-weight-medium auth-form-btn btn-login" (click)="openLogin('')">sign in</button>
            </li>
            <li class="nav-item">
                <button *ngIf="env.host.signUpActive" class="btn btn-block btn-gradient-primary btn-sm font-weight-medium auth-form-btn btn-login" (click)="openSignUpModal()">signup</button>
            </li>
        </ul>
        <button *ngIf="!router.url.includes('/home')" class="navbar-toggler navbar-toggler-right d-lg-none align-self-center" type="button"
            data-toggle="offcanvas">
            <span class="mdi mdi-menu"></span>
        </button>
    </div>
</nav>
<!-- partial -->

<a *ngIf="(env.wpLinkShowPages.includes(router.url.split('/')[1])) && wpLink != ''" class="whatsapp_link" [href]="wpLink" target="_blank"><img src="https://speedcdn.io/assets/parker-client/wp_support.png"></a>

<div class="modal fade promotion-popup" bsModal #afterLoginModal="bs-modal"
    [config]="{show: false , backdrop: false, ignoreBackdropClick: false}" tabindex="-1" role="dialog" aria-labelledby="">
    <div class="modal-dialog bookModal app_version">
        <div class="modal-content modal-content-centered">
            <div class="modal-body p-0">
                <button style="position: absolute;right: 13px;top: 1px;color: #fff;font-size: 21px;" type="button" class="close" data-bs-dismiss="modal" aria-label="Close"
                    (click)="afterLoginModal.hide()">
                    <span aria-hidden="true">&times;</span>
                </button>
                <a href="javascript:void(0)" (click)="afterLoginModal.hide()">
                    <img src="https://speedcdn.io/assets/parker-client/popup.jpg" style="width: 100% !important;">
                </a>
            </div>
        </div>
    </div>
</div>